//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttachmentStyle } from './Enums';

export class AttendanceAttachmentInputItem extends ItemBase {
    LibraryOnlineItemID: string | null = null;
    AttachmentStyle: AttachmentStyle = AttachmentStyle.Attached;
    AllowDownload: boolean = false;

    constructor(initializer?: Partial<AttendanceAttachmentInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceAttachmentInputItem";
}
